export const MIN_CAPTURE_FPS = 1
export const DEFAULT_CAPTURE_FPS = 4
export const MAX_CAPTURE_FPS = 8

export function normalizeCaptureFps(value: number | undefined): number {
  if (!Number.isFinite(value)) return DEFAULT_CAPTURE_FPS
  return Math.min(MAX_CAPTURE_FPS, Math.max(MIN_CAPTURE_FPS, Math.round(value!)))
}

export function captureIntervalMs(captureFps: number | undefined): number {
  return Math.round(1_000 / normalizeCaptureFps(captureFps))
}

export function scaleRecognitionIntervalMs(baseIntervalMs: number, captureFps: number | undefined): number {
  return Math.max(1, Math.round(baseIntervalMs * DEFAULT_CAPTURE_FPS / normalizeCaptureFps(captureFps)))
}
